import { lazyWithReload } from '../../utils/lazyWithReload';
/**
 * Registers the standalone page renderer for Sheet / Spreadsheet entity types.
 *
 * Import this file as a side effect once at app startup (done from appRegistryStore.ts).
 * The registry is a singleton so it is safe to import multiple times (idempotent Map.set).
 *
 * Rendered at /sheets/:id  (standaloneAlias defined in entityLinkCapabilities.ts)
 * and at /entity/:id when the entity type resolves to Sheet or Spreadsheet.
 *
 * The rendered component is <SheetsApp_v2> — StandaloneEntityLayout provides the outer
 * chrome (top bar, share button, "Open in Space" link), so we render only the sheet grid.
 */

import React from 'react';
import { entityStandaloneRegistry, StandaloneRendererContext } from '../../components/StandaloneEntity/entityStandaloneRegistry';

const SheetsApp_v2 = lazyWithReload(() =>
  import('./SheetsApp_v2').then(m => ({ default: m.SheetsApp_v2 }))
);

function renderSheet(ctx: StandaloneRendererContext) {
  const entityId = ctx.entity._id || (ctx.entity as any).id || '';
  return React.createElement(SheetsApp_v2, { entityId });
}

const sheetRenderer = {
  appId: 'sheets-v2',
  render: renderSheet,
};

entityStandaloneRegistry.register('Sheet', sheetRenderer);
entityStandaloneRegistry.register('Spreadsheet', sheetRenderer);
